import { Component } from '@angular/core';
import {TranslateService} from "@ngx-translate/core";
import { marker as _i18n } from '@biesbjerg/ngx-translate-extract-marker';
import {AccountService} from "@app/services";
import {PermissionsService} from "@app/services/permissions.service";
import {environment} from "@environments/environment";
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.sass']
})
export class AppComponent {
  title = _i18n('DoItYourself');
  constructor(
    private translate: TranslateService,
    private accountService: AccountService,
    private permissionsService: PermissionsService,
  ) {
    accountService.user.subscribe(user => {
      if(user && user.language){
        translate.setDefaultLang(user.language);
        translate.use(user.language);
      }else{
        translate.setDefaultLang(environment.LANGUAGE_DEFAULT);
        translate.use(environment.LANGUAGE_DEFAULT);
      }
    })
  }
}
